import * as yup from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  const defaultMinDate = new Date('01/01/1000');

  const defaultMaxDate = new Date('12/31/3000');

  return yup.object({
    [`${formatName(properties['label']?.$id as string)}`]: yup
      .string()
      .required('Required')
      .max(250, 'Must be at most 250 characters'),
    [`${formatName(properties['id']?.$id as string)}`]: yup
      .string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(properties['required']?.$id as string)}`]: yup.boolean(),
    [`${formatName(properties['minimumDate']?.$id as string)}`]: yup
      .date()
      .typeError('Date must be MM/DD/YYYY')
      .test('lessThan', 'Must be less than maximum date', function (value) {
        const maximumDate = this.parent[
          formatName(properties['maximumDate']?.$id as string)
        ] as Date;
        return !!value && value?.getTime() < maximumDate.getTime();
      })
      .min(
        defaultMinDate,
        `Date must be greater than or equal to ${defaultMinDate.toLocaleDateString()}`
      )
      .max(
        defaultMaxDate,
        `Date must be less than or equal to ${defaultMaxDate.toLocaleDateString()}`
      ),
    [`${formatName(properties['maximumDate']?.$id as string)}`]: yup
      .date()
      .typeError('Date must be MM/DD/YYYY')
      .test('moreThan', 'Must be greater than minimum date', function (value) {
        const minimumDate = this.parent[
          formatName(properties['minimumDate']?.$id as string)
        ] as Date;
        return !!value && value?.getTime() > minimumDate.getTime();
      })
      .min(
        defaultMinDate,
        `Date must be greater than or equal to ${defaultMinDate.toLocaleDateString()}`
      )
      .max(
        defaultMaxDate,
        `Date must be less than or equal to ${defaultMaxDate.toLocaleDateString()}`
      ),
    [`${formatName(properties['gridSize']?.$id as string)}`]: yup.number()
  });
};
